import React, { useMemo } from "react";

import ScreeningChatbot from "./ScreeningChatbot";
import ScreeningSalaryRange from "./ScreeningSalaryRange";

const CONFIGURATION_COMPONENTS = {
  chatbot: ScreeningChatbot,
  salary: ScreeningSalaryRange
};

function ConfigurationComponent({ t, type, ...props }) {
  const Component = useMemo(() => CONFIGURATION_COMPONENTS[type], [type]);
  return (
    <div>
      <Component t={t} {...props} />
    </div>
  );
}

export default ConfigurationComponent;
